import formBuilder from '@/components/familyPortal/forms/formBuilder/Container/Container.vue'
import SessionTimeout from '@/components/familyPortal/popupComponents/sessionTimeout/SessionTimeout.vue'
import APP_CONST from '@/constants/AppConst'
import AccountSettings from '@/mixins/accountSettings.mixin'
import applicationStore from '@/store/modules/applications/applicationStore'
import formsStore from '@/store/modules/forms/formsStore'
import APP_UTILITIES from '@/utilities/commonFunctions'
import UIkit from 'uikit'
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { scholarInformation } from './formBuilder/Container/formData/scholarDetails'

@Component({
  name: 'forms-list',
  components: {
    'form-elements': formBuilder,
    'session-timeout': SessionTimeout
  }
})
export default class Forms extends Mixins(AccountSettings) {
  @Prop({ type: Boolean, default: false }) readonly isCheckout!: boolean

  applicationData: any = {}
  public builderData: any = []
  public isMobileView: boolean = true
  public localConst: any = APP_CONST
  public guardianData: any = {}
  public ecs: any = []
  public ecsOrdered: any = []
  public existingOrders: any = []
  public scholarInformation = scholarInformation

  /* istanbul ignore next */
  @Watch('applicationParts', { deep: true })
  watchdata(val: any) {
    this.structureFormData(val)
  }

  /* istanbul ignore next */
  get sitesList() {
    return applicationStore.sitesList
  }

  /* istanbul ignore next */
  get siteIds() {
    const siteIds: number[] = []
    if (this.sitesList.length) {
      this.sitesList.forEach((session) => {
        if (session.selected) {
          siteIds.push(session.sessionId)
        }
      })
    }
    return siteIds
  }

  /* istanbul ignore next */
  get applicationName() {
    return this.applicationData.name
  }

  /* istanbul ignore next */
  get applicationParts() {
    return formsStore.applicationsPartsData.forms
  }

  /* istanbul ignore next */
  get applicationsList() {
    return formsStore.applicationsData
  }

  /* istanbul ignore next */
  get applicationsPart() {
    return formsStore.applicationsParts
  }

  /* istanbul ignore next */
  get formsList() {
    return formsStore.formsList
  }

  /* istanbul ignore next */
  get elasticEnrollmentId() {
    return formsStore.getElasticEnrollmentId
  }

  get currentPartIndex() {
    return formsStore.currentPartNumber
  }

  get getChangeSite() {
    return applicationStore.changeSite
  }

  /* istanbul ignore next */
  get isNextButton() {
    if (
      APP_UTILITIES.getCookie('outStandingItems') ||
      APP_UTILITIES.getCookie('outStandingItemIndex')
    ) {
      const application: any = JSON.parse(APP_UTILITIES.getCookie('outStandingItems') || '')
      const currentIndex: any = JSON.parse(APP_UTILITIES.getCookie('outStandingItemIndex') || '')
      if (application[currentIndex] && application[currentIndex].isDocumentSubmitted) {
        if (application.length == currentIndex + 1) {
          return false
        } else {
          return true
        }
      }
      return true
    } else {
      return false
    }
  }

  get scholarId() {
    const currentIndex: any = APP_UTILITIES.getCookie('outStandingItemIndex')
    const outStandingItems: any = APP_UTILITIES.getCookie('outStandingItems')
    const currentOutstandingItem = JSON.parse(outStandingItems)[currentIndex]
    return this.applicationData.scholarId !== '00000000-0000-0000-0000-000000000000'
      ? this.applicationData.scholarId
      : currentOutstandingItem.scholarId
  }

  get scholarPartFirstDetails() {
    return formsStore.scholarData
  }

  get requiredFilledData() {
    return formsStore.formValidation
  }

  get isPartOneFecthed() {
    return formsStore.isPartOneFormsFetched
  }

  previous() {
    formsStore.updateCurrentUpdatedField({ name: '', value: '', order: '' })
    formsStore.saveCurrentBirthDate('')
    const application: any = APP_UTILITIES.getCookie('outStandingItems')
    if (application) {
      const currentIndex: any = JSON.parse(APP_UTILITIES.getCookie('outStandingItemIndex') || '')
      if (currentIndex == 0) {
        return
      } else if (!application[currentIndex - 1].isDocumentSubmitted) {
        formsStore.resetApplication()
        applicationStore.updatePartIndex({ submissions: application, index: currentIndex - 1 })
        this.$router.push(APP_CONST.APP_ROUTES.APPLICATION_UPLOAD_DOCUMENTS.path)
      } else {
        applicationStore.updatePartIndex({ submissions: application, index: currentIndex - 1 })
        this.getFormDetails()
      }
    } else {
      formsStore.resetApplication()
    }
  }

  submitBtn(arg: any) {
    formsStore.saveFinalApplicationForms(arg)
  }

  getUpdateFormElements(elementData: any, element: any, parentItemName?: any) {
    element.columns.forEach((column: any) => {
      /* istanbul ignore else */
      if (column.list) {
        column.list.forEach((listItem: any) => {
          if (
            listItem.name != APP_CONST.DIVIDERLINE_TEXT &&
            listItem.name != APP_CONST.TEXTAREALONGQUESTION_TEXT
          ) {
            if (listItem.columns) {
              if (element.name == 'emergencyContact' || element.name == 'authorizedInformation') {
                this.getUpdateFormElements(elementData, listItem, listItem.name)
              } else {
                this.getUpdateFormElements(elementData, listItem)
              }
            } else {
              if (listItem.type == 'consentcheckbox') {
                elementData[listItem.name] =
                  listItem.options.options &&
                  listItem.options.options[0] &&
                  listItem.options.options[0].value
                if (listItem.options.defaultValue) {
                  elementData['consent_Label'] =
                    listItem.options.options &&
                    listItem.options.options[0] &&
                    listItem.options.options[0].value
                }
              } else {
                if (listItem.name.includes('emergency') || listItem.name.includes('authorized')) {
                  if (parentItemName) {
                    parentItemName =
                      parentItemName == 'emergencyContactName'
                        ? 'emergencyContact'
                        : parentItemName == 'authorizedInformation'
                          ? 'authorizedContact'
                          : parentItemName
                    elementData[parentItemName] = {
                      ...elementData[parentItemName],
                      [listItem.name]: listItem.options.defaultValue
                    }
                  } else {
                    elementData[listItem.name] = listItem.options.defaultValue
                  }
                } else {
                  elementData[listItem.name] = listItem.options.defaultValue
                }
              }
            }
          }
        })
      }
    })
    return elementData
  }

  getUpdatedFormattedDetails(data: any, column: string, content: any) {
    /* istanbul ignore else */
    if (typeof content !== 'undefined') {
      if (Object.keys(content).length) {
        Object.keys(content).forEach((elemKey: any) => {
          if (content.hasOwnProperty(elemKey)) {
            data[elemKey].push(content[elemKey])
          }
        })
      }
    }
    return data
  }

  getFormattedDetails(data: any, column: string, content: any, order?: any) {
    /* istanbul ignore else */
    if (
      typeof content !== 'undefined' &&
      (column != this.localConst.DIVIDERLINE_TEXT ||
        column != this.localConst.TEXTAREALONGQUESTION_TEXT)
    ) {
      if (data[column]) {
        if (
          (column.includes('guardian') && data[column].length < 2) ||
          !column.includes('guardian')
        ) {
          if (
            order &&
            (!this.guardianData[column] ||
              (this.guardianData[column] && this.guardianData[column] != order))
          ) {
            this.guardianData = { ...this.guardianData, [column]: order }
            data[column][data[column].length] = content
            // swap if guardian 2 at index 0 and when 2 guardians are alraedy added
            if (data[column].length == 2 && column.includes('guardian') && order == 'guardian_1') {
              data[column] = [data[column][1], data[column][0]]
            }
          } else if (!column.includes('guardian')) {
            data[column][data[column].length] = content
          }
        } else if (column.includes('guardian') && data[column].length < APP_CONST.TWO) {
          data[column][data[column].length] = content
        }
      } else {
        if (column.includes('guardian') && order) {
          this.guardianData = { ...this.guardianData, [column]: order }
        }
        data = { ...data, [column]: [content] }
      }
    }
    return data
  }

  structureFormData(applicationParts: any) {
    this.builderData = {
      scholar: {},
      guardians: {},
      customFields: [],
      emergencyContacts: {
        emergencyContact: [],
        emergencyPhoneNumberType: [],
        emergency_callorder: [],
        emergency_relation: []
      },
      documents: [],
      consents: [],
      siteDetails: {},
      scholarMapping: {
        scholar_Guid: '',
        accountId: this.applicationData.accountId,
        applicationId: this.applicationData.elasticApplicationId,
        submissionId: 0,
        elasticSubmissionId: '',
        programId: 0,
        siteIds: []
      },
      learning: {},
      medical: {},
      programDetails: {},
      pickUps: {
        authorizedContact: [],
        authorized_relation: [],
        authorizedPhoneNumberType: [],
        authorizedDate: []
      },
      scheduleDays: []
    }
    const scholarId: any = APP_UTILITIES.getCookie('scholarId') || ''
    this.builderData.scholarMapping.scholar_Guid = scholarId ? JSON.parse(scholarId) : ''
    this.builderData.scholarMapping.applicationId = this.applicationData.applicationGuid
      ? this.applicationData.applicationGuid
      : ''
    this.builderData.scholarMapping.elasticSubmissionId = this.elasticEnrollmentId
    this.builderData.scholarMapping.siteIds = localStorage.getItem('all_selected_sites')
    this.builderData.scholarMapping.programId = this.applicationData.programId
    this.builderData.scholarMapping.accountId = this.applicationData.accountId
    this.applicationParts &&
      this.applicationParts.forEach((form: any) => {
        this.buildFormData(form.formId, form.source)
      })
    if (!applicationStore.selectedChild.id && this.currentPartIndex < 1) {
      this.provideBuilderDataForTempScholars()
    }

    formsStore.updateFormsStructure(JSON.stringify(this.builderData))
  }

  provideBuilderDataForTempScholars() {
    const tempScholarData = applicationStore.allSelectedChildData
    if (tempScholarData) {
      this.builderData.scholar.scholarName.scholar_firstname = tempScholarData.firstName
      this.builderData.scholar.scholarName.scholar_lastname = tempScholarData.lastName
      // date has to be formatted for elastic as 'MM - DD - YYYY'
      const formattedDOB = APP_UTILITIES.formatFullDateForElastic(tempScholarData.DOB as string)
      this.builderData.scholar.scholarbirthdateField.scholar_birthdate = formattedDOB
    }
  }

  updateRelationDropdown(formJSON: any) {
    formJSON.parts.forEach((partElm: any) => {
      if (partElm.forms && partElm.forms.length) {
        partElm.forms.forEach((frmElm: any, frmIndex: number) => {
          if (frmElm && frmElm.source && frmElm.source.list.length) {
            frmElm.source.list.forEach((item: any) => {
              if (item.name === 'emergencyContact') {
                item.columns.forEach((itm: any) => {
                  itm.list.forEach((element: any) => {
                    if (element.name == 'emergency_relation') {
                      element.options.options.forEach((option: any) => {
                        const opt1 = option && option.label && option.label.trim()
                        const opt2 = option && option.value && option.value.trim()
                        if (opt1 == 'Others' || opt2 == 'Others') {
                          option.label = 'Other'
                          option.value = 'Other'
                        }
                      })
                    }
                  })
                })
              } else if (
                item.elmType == 'custom' &&
                (item.name == 'guardian_relation' ||
                  item.name == 'emergency_relation' ||
                  item.name == 'authorized_relation' ||
                  item.name == 'scholar_race') &&
                item.type == 'dropdown'
              ) {
                item.options.options.forEach((option: any) => {
                  const opt1 = option && option.label && option.label.trim()
                  const opt2 = option && option.value && option.value.trim()
                  if (opt1 == 'Others' || opt2 == 'Others') {
                    option.label = 'Other'
                    option.value = 'Other'
                  }
                })
              }
            })
          }
        })
      }
    })
  }

  updateLanguageDropdown(formJSON: any) {
    formJSON.parts.forEach((partElm: any) => {
      if (partElm.forms && partElm.forms.length) {
        partElm.forms.forEach((frmElm: any, frmIndex: number) => {
          if (frmElm && frmElm.source && frmElm.source.list.length) {
            frmElm.source.list.forEach((item: any) => {
              if (
                item.elmType == 'custom' &&
                (item.name == 'scholar_language' || item.name == 'guardian_language') &&
                item.type == 'dropdown'
              ) {
                item.options.options.forEach((option: any) => {
                  const opt1 = option && option.value && option.value.trim()
                  if (opt1 == 'Portuguese') {
                    scholarInformation.getScholar().forEach((elem: any) => {
                      if (
                        elem.elmType == 'custom' &&
                        elem.name == 'scholar_language' &&
                        elem.type == 'dropdown'
                      ) {
                        item.options.options = elem.options.options
                      }
                    })
                  }
                })
              }
            })
          }
        })
      }
    })
  }

  groupEmergencyContactsData(element: any) {
    const columnName = `${element.name}`
    let orderIndex = -1
    let groupName = ''
    if (groupName == '' && element.group != undefined && element.group != '') {
      groupName = element.group
    }

    if (
      columnName == 'emergency_callorder' &&
      element.options.defaultValue != undefined &&
      element.options.defaultValue != ''
    ) {
      orderIndex = parseInt(element.options.defaultValue)
      if (this.ecs[this.ecs.length - 1]) {
        this.ecs[this.ecs.length - 1].orderIndex = orderIndex
      }
      this.existingOrders.push(orderIndex)
    }

    if (columnName == 'emergencyContact') {
      if (this.ecs.length > 0 && this.ecs[this.ecs.length - 1].orderIndex == undefined) {
        this.ecs[this.ecs.length - 1].orderIndex = orderIndex
      }
      this.ecs.push({ orderIndex: -1, items: new Array() })
    }
    this.ecs[this.ecs.length - 1] && this.ecs[this.ecs.length - 1].items.push(element)
  }

  prepareEmergencyContactDetails() {
    let i: number = 0
    let j: number = 0

    this.ecsOrdered = JSON.parse(JSON.stringify(this.ecs))
    const leng: number = this.ecs.length
    const groupName: string = ''

    for (i = 0; i < this.ecs.length; i++) {
      if (this.ecs[i].orderIndex == -1) {
        for (j = 0; j < this.ecs.length; j++) {
          if (this.existingOrders.indexOf(j + 1) == -1) {
            this.ecs[i].orderIndex = j + 1
            this.ecs[i].items.push({
              options: { defaultValue: (j + 1).toString() },
              name: 'emergency_callorder',
              group: groupName == '' ? 'emergencyContactDetails' : groupName
            })
            this.existingOrders.push(j + 1)
            break
          }
        }
      }
    }
    this.ecs.sort((a: any, b: any) => (a.orderIndex > b.orderIndex ? 1 : -1))

    for (i = 0; i < this.ecs.length; i++) {
      for (j = 0; j < this.ecs[i].items.length; j++) {
        const element = this.ecs[i].items[j]
        const columnName = `${element.name}`

        if (!['dividerLine', 'sectionHeader'].includes(element.name)) {
          if (element.columns) {
            const elementData = {}
            const elementContent = this.getUpdateFormElements(elementData, element)
            switch (element.group) {
              case 'emergencyContactsDetails':
                if (
                  columnName == 'emergencyPhoneNumberType' &&
                  elementContent.emergency_phone &&
                  elementContent.emergency_phone.includes([')', '(', ' '])
                ) {
                  elementContent.emergency_phone = elementContent.emergency_phone.replace(/\D/g, '')
                }
                this.builderData.emergencyContacts = this.getUpdatedFormattedDetails(
                  this.builderData.emergencyContacts,
                  element.name,
                  elementContent
                )

                break
              case 'emergencyContactDetails':
                if (
                  columnName == 'emergencyPhoneNumberType' &&
                  elementContent.emergency_phone &&
                  elementContent.emergency_phone.includes([')', '(', ' '])
                ) {
                  elementContent.emergency_phone = elementContent.emergency_phone.replace(/\D/g, '')
                }
                this.builderData.emergencyContacts = this.getFormattedDetails(
                  this.builderData.emergencyContacts,
                  columnName,
                  elementContent
                )
                break
            }
          } else {
            const defaultVal = element.options.defaultValue
            switch (element.group) {
              case 'emergencyContactsDetails':
                break
              case 'emergencyContactDetails':
                if (
                  (columnName === 'emergency_callorder' || columnName === 'emergency_relation') &&
                  defaultVal != 'Select'
                ) {
                  this.builderData.emergencyContacts = this.getFormattedDetails(
                    this.builderData.emergencyContacts,
                    columnName,
                    defaultVal
                  )
                }
                break
            }
          }
        }
      }
    }
  }

  buildFormData(formId: string, formData: any): void {
    /* istanbul ignore else */
    this.ecs = []
    this.ecsOrdered = []
    if (formData.list && formData.list.length > 0) {
      formData.list.forEach((element: any, index: number) => {
        const columnName: string = `${element.name}`
        /* istanbul ignore else */
        if (!['dividerLine', 'sectionHeader'].includes(element.name)) {
          if (element.columns) {
            const elementData: any = {}
            const elementContent: any = this.getUpdateFormElements(elementData, element)
            switch (element.group) {
              case 'scholarDetails':
                if (
                  columnName == 'scholarPhoneNumberType' &&
                  elementContent.scholar_phone &&
                  elementContent.scholar_phone.includes([')', '(', ' '])
                ) {
                  elementContent.scholar_phone = elementContent.scholar_phone.replace(/\D/g, '')
                }
                this.builderData.scholar = {
                  ...this.builderData.scholar,
                  [columnName]: elementContent
                }
                break
              case 'guardianDetails':
                this.builderData.guardians = this.getFormattedDetails(
                  this.builderData.guardians,
                  columnName,
                  elementContent,
                  element.order
                )
                break
              case 'customFieldDetails':
                this.builderData.customFields = this.getFormattedDetails(
                  this.builderData.customFields,
                  columnName,
                  elementContent
                )
                break
              case 'emergencyContactsDetails':
                if (
                  columnName == 'emergencyPhoneNumberType' &&
                  elementContent.emergency_phone &&
                  elementContent.emergency_phone.includes([')', '(', ' '])
                ) {
                  elementContent.emergency_phone = elementContent.emergency_phone.replace(/\D/g, '')
                }
                this.groupEmergencyContactsData(element)
                break
              case 'emergencyContactDetails':
                if (
                  columnName == 'emergencyPhoneNumberType' &&
                  elementContent.emergency_phone &&
                  elementContent.emergency_phone.includes([')', '(', ' '])
                ) {
                  elementContent.emergency_phone = elementContent.emergency_phone.replace(/\D/g, '')
                }
                this.groupEmergencyContactsData(element)
                break
              case 'scholarSiteDetails':
                this.builderData.siteDetails = {
                  ...this.builderData.siteDetails,
                  [columnName]: elementContent
                }
                break
              case 'scholarLearningDetails':
                this.builderData.learning = {
                  ...this.builderData.learning,
                  [columnName]: elementContent
                }
                break
              case 'scholarMedicalDetails':
                this.builderData.medical = {
                  ...this.builderData.medical,
                  [columnName]: elementContent
                }
                break
              case 'scholarProgramDetails':
                this.builderData.programDetails = {
                  ...this.builderData.programDetails,
                  [columnName]: elementContent
                }
                break
              case 'authorizedInfoDetails':
                this.builderData.pickUps = this.getUpdatedFormattedDetails(
                  this.builderData.pickUps,
                  columnName,
                  elementContent
                )
                break
              case 'authorizedInfo':
                this.builderData.pickUps = this.getFormattedDetails(
                  this.builderData.pickUps,
                  columnName,
                  elementContent
                )
                break
              case 'consentInfo':
                this.builderData.consents.push({
                  consent_Question: elementContent.consent_ques,
                  consent_Answer: elementContent.consent_Label ? elementContent.consent_Label : '',
                  consent_Ack: elementContent.consent_response,
                  consent_Options: `${elementContent.consent_agreement1},${elementContent.consent_agreement}`,
                  elasticform_Id: formId
                })
                break

              default:
                break
            }
          } else {
            let defaultVal: any = element.options.defaultValue
            switch (element.group) {
              case 'scholarDetails':
                this.builderData.scholar = { ...this.builderData.scholar, [columnName]: defaultVal }
                break
              case 'guardianDetails':
                this.builderData.guardians = this.getFormattedDetails(
                  this.builderData.guardians,
                  columnName,
                  defaultVal,
                  element.order
                )
                break
              case 'customFieldDetails':
                if (Array.isArray(defaultVal) && defaultVal.length) {
                  defaultVal = defaultVal.join(',')
                } else if (Array.isArray(defaultVal) && defaultVal.length < 1) {
                  defaultVal = ''
                }
                this.builderData.customFields.push({
                  custom_Response: defaultVal,
                  custom_Field: columnName,
                  custom_Question: element.label
                })
                break
              case 'emergencyContactsDetails':
                this.groupEmergencyContactsData(element)
                break
              case 'emergencyContactDetails':
                this.groupEmergencyContactsData(element)
                break
              case 'scholarSiteDetails':
                this.builderData.siteDetails = {
                  ...this.builderData.siteDetails,
                  [columnName]: defaultVal
                }
                break
              case 'scholarLearningDetails':
                this.builderData.learning = {
                  ...this.builderData.learning,
                  [columnName]: defaultVal
                }
                break
              case 'scholarMedicalDetails':
                this.builderData.medical = { ...this.builderData.medical, [columnName]: defaultVal }
                break
              case 'scholarProgramDetails':
                this.builderData.programDetails = {
                  ...this.builderData.programDetails,
                  [columnName]: defaultVal
                }
                break
              case 'authorizedInfoDetails':
                this.builderData.pickUps = this.getFormattedDetails(
                  this.builderData.pickUps,
                  columnName,
                  defaultVal
                )
                break
              case 'authorizedInfo':
                this.builderData.pickUps = this.getFormattedDetails(
                  this.builderData.pickUps,
                  columnName,
                  defaultVal
                )
                break
              default:
                break
            }
          }
        }
      })
      this.prepareEmergencyContactDetails()
    }
  }

  isMobile() {
    this.isMobileView = APP_UTILITIES.isMobile()
  }

  beforeMount() {
    if (APP_UTILITIES.getCookie('outStandingItems')) {
      formsStore.mutateCurrentPart(APP_CONST.ONE)
    } else {
      formsStore.mutateCurrentPart(APP_CONST.ZERO)
    }
  }

  mounted() {
    formsStore.resetGuardianDetails()
    formsStore.resetEmergencyFields()
    formsStore.resetFields()
    formsStore.resetFormModels()

    this.getFormDetails()
    // formsStore.getUserDetails().then((res:any)=>{debugger})
  }

  getFormDetails() {
    /* istanbul ignore else */
    if (applicationStore.applicationDataInfo) {
      this.applicationData = applicationStore.applicationDataInfo
      if (localStorage.scholar_selected == 'false') {
        // formsStore.resetApplication();
        if (!this.elasticEnrollmentId) {
          formsStore
            .getApplicationDetails(this.applicationData.elasticApplicationId)
            .then((data: any) => {
              this.updateRelationDropdown(data)
              this.updateLanguageDropdown(data)
              if (this.currentPartIndex > 0 && this.scholarId) {
                formsStore.getScholarData(this.scholarId)
              }
            })
        } else {
          formsStore.getElasticApplicationDetails(this.elasticEnrollmentId)
          if (this.currentPartIndex > 0 && this.scholarId) {
            formsStore.getScholarData(this.scholarId)
          }
        }
      } else {
        // formsStore.getElasticApplicationsIdDetails(localStorage.scholar_guid);
      }
    }
    this.isMobile()
  }

  destroyed() {
    formsStore.mutateWidgetList([])
    applicationStore.mutateChangeSite(false)
    if (UIkit.modal('#modal-application-sent')) {
      UIkit.modal('#modal-application-sent').$destroy(true)
    }
  }
}
